
import Ethereum from "../../../assets/filled/Ethereum.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EthereumIcon({ className, dataTestid = "EthereumIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ethereum data-testid={dataTestid} className={classes} {...rest} />
  );
}
